// Some in-app browsers hand the page no storage at all: an Android WebView with DOM
// storage switched off answers `window.localStorage` with null (seen 2026-09-29 in the
// Cici/Dola assistant's browser), and the first page that read it crashed with "Cannot
// read properties of null (reading 'getItem')". There, a stand-in that lives as long as
// the tab keeps the app usable; everything the app keeps in storage is a convenience.
// Imported before anything else in index.jsx, so no module reads storage first.

export function memoryStorage() {
  const items = new Map();
  return {
    get length() { return items.size; },
    key: (index) => Array.from(items.keys())[index] ?? null,
    getItem: (key) => (items.has(String(key)) ? items.get(String(key)) : null),
    setItem: (key, value) => { items.set(String(key), String(value)); },
    removeItem: (key) => { items.delete(String(key)); },
    clear: () => { items.clear(); },
  };
}

export function installStorageFallback(win = typeof window === 'undefined' ? null : window) {
  if (!win) return [];
  const replaced = [];
  for (const name of ['localStorage', 'sessionStorage']) {
    let storage;
    try {
      storage = win[name];
    } catch {
      // Blocked storage throws on access in some browsers; the app already guards those reads
      continue;
    }
    if (storage) continue;
    try {
      Object.defineProperty(win, name, { value: memoryStorage(), configurable: true });
      replaced.push(name);
    } catch {
      // Nothing more to do: the page keeps the browser's own answer
    }
  }
  return replaced;
}

installStorageFallback();
